export default __webpack_public_path__ + "static/media/SynchroBus blanc2_1.b1e33187.png";